export default function SimpleCard({ children }: { children: React.ReactNode }) {
    return (
        <div style={{
            width: "100%",
            display: "grid",
            border: '1px solid var(--border-color)',
            margin: 'auto',
            borderRadius: '5px',
            background: 'var(--input-bg-color)',
            alignContent: 'center',
            marginTop: '10px',
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "15px",
            color: 'var(--primary-text-color)',
        }}>
            {children}
        </div>
    )
}
